module.exports = __webpack_public_path__ + "img/itx-file-type-zip.055c3296.svg";